/**
 * Shared bot avatar used across agent-originated chat items.
 */

import { BotIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Avatar, AvatarFallback } from '@/components/ui/avatar'

export const ChatBotAvatar: React.FC = (): ReactNode => (
  <Avatar className="size-8">
    <AvatarFallback className="bg-primary text-primary-foreground">
      <BotIcon className="size-4" />
    </AvatarFallback>
  </Avatar>
)

ChatBotAvatar.displayName = 'ChatBotAvatar'
